module.exports = __webpack_public_path__ + "img/gmail.41fec935.png";